import { getBrand, getHostName } from '@blockpulse3/data/shared';

import {
  AxerealTheme,
  BlastTheme,
  BlockpulseTheme,
  CenitzTheme,
  HowhenTheme,
  InvestTheme,
  LesaffreTheme,
  PbaTheme,
  StomeaTheme,
  VivaltoTheme,
  YeastTheme,
} from '../brands';
import { Brand } from '../brands/types';

export function getBrandTheme(): Brand {
  const hostname = getHostName();
  const brand = getBrand(hostname);

  switch (brand) {
    case 'blast':
      return BlastTheme;
    case 'blockpulse':
      return BlockpulseTheme;
    case 'howhen':
      return HowhenTheme;
    case 'axereal':
      return AxerealTheme;
    case 'pba':
      return PbaTheme;
    case 'cenitz':
      return CenitzTheme;
    case 'invest':
      return InvestTheme;
    case 'stomea':
      return StomeaTheme;
    case 'lesaffre':
      return LesaffreTheme;
    case 'vivalto':
      return VivaltoTheme;
    case 'yeast':
      return YeastTheme;
    default:
      return BlockpulseTheme;
  }
}
